import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoints from '../../../../../common/hooks/useBreakpoints';
import Carousel from '../../../../../common/widgets/Carousel';
import { parseProducts } from '../../../helpers';
import { resources } from '../../../resources/resources';
import ProductListItem from '../../Common/ProductListItem';
import { CarouselsContext } from '../../../contexts/CarouselsProvider';

export default function TopDeals() {
  const { t: translate } = useTranslation();
  const { isOnlyDesktop, isOnlyTablet, isOnlyMobile } = useBreakpoints();
  const { topDeals, loading } = useContext(CarouselsContext);

  const products = parseProducts(topDeals);
  const productCount = products?.length ?? 0;

  const showCardList =
    (isOnlyDesktop && productCount <= 4) ||
    (isOnlyTablet && productCount <= 3) ||
    (isOnlyMobile && productCount <= 2.5);

  if (!products?.length) {
    return null;
  }

  return (
    <section className="page-section carousel-section mb-60">
      <h2 className="section-title">
        <span>{translate(resources.home.title.topDeals)}</span>
      </h2>
      <div
        className={`edn-carousel edn-carousel-dots no-dots-tablet no-dots-mobile ${
          isOnlyDesktop && productCount > 4
            ? ' home-product-carousel--with-pagination'
            : ''
        }`}
      >
        {showCardList ? (
          <div className="card-list">
            {(products ?? []).map(product => (
              <ProductListItem
                key={product.productId ?? product.brandId}
                product={product}
              />
            ))}
          </div>
        ) : (
          <Carousel
            dots={productCount > 4}
            infinite={false}
            speed={500}
            slidesToShow={4}
            slidesToScroll={productCount <= 4 ? 1 : 4}
            arrows={false}
            swipe={productCount > 4}
            draggable={productCount > 4}
            touchMove={productCount > 4}
            loading={loading.topDeals}
            responsive={[
              {
                breakpoint: 992,
                settings: {
                  dots: false,
                  slidesToShow: 3,
                  slidesToScroll: productCount <= 3 ? 1 : 3,
                  swipe: productCount > 3,
                  draggable: productCount > 3,
                  touchMove: productCount > 3,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2.5,
                  slidesToScroll: productCount <= 2.5 ? 1 : 2.5,
                  swipe: productCount > 2.5,
                  draggable: productCount > 2.5,
                  touchMove: productCount > 2.5,
                },
              },
            ]}
          >
            {(products ?? []).map(product => (
              <ProductListItem
                key={product.productId ?? product.brandId}
                product={product}
              />
            ))}
          </Carousel>
        )}
      </div>
    </section>
  );
}
